import React, { useEffect, useState } from 'react'
import { Button, Image } from 'react-bootstrap'
import BootstrapTable from 'react-bootstrap-table-next'
import Paginador, { PaginationProvider } from 'react-bootstrap-table2-paginator'
import { useQuery } from 'react-query'
import { connect, useDispatch, useSelector } from 'react-redux'

import ColetaClickstream from '../../../components/clickstreamAnalise/clickstreamColeta.js'
import { api_gateway } from '../../../conexoes/api'
import {
  desabilitarAcoes,
  desabilitarAcoesCliente,
  realizouBusca,
  limpouBusca,
  realizouFiltro,
  mudarDoppleGangerCliente,
  mudarManejador,
  revelarDoppelgangerCliente,
  visualizarDadosRefresh
} from '../../../redux/actions/index'
import { useGlobal } from '../../../stores/useGlobal.js'
import { setaDropdown } from '../../../utils/alternanciaIcones'
import decryptJWT from '../../../utils/decryptJWT'
import { formatarData } from '../../../utils/formatadorDataTabela'
import { formatBusca } from '../../../utils/genericFormatters.js'
import GirarSetaDropdown from '../../../utils/girarSetaDropdown'
import PaginacaoTabela from '../../../utils/paginacaoTabela'
import { requestResolver } from '../../../utils/requestResolver.js'
import BarraDadosCliente from '../../componentesModais/barraDadosCliente/barraDadosCliente'
import BarraFiltragem from '../../componentesModais/barraFiltragem/barraFiltragem'
import MensagemErro from '../../componentesModais/mensagens/mensagemErro'
import MensagemSucesso from '../../componentesModais/mensagens/mensagemSucesso'
import AdicionarLogin from '../adicionarLogin/adicionarLogin'
import BloqueioPorConsumoPercentual from '../bloqueioPorConsumoPercentual/index.jsx'
import CadastroCliente from '../cliente/cadastro/cadastro'
import ConsultarSimcard from '../consultarSimcard/consultarSimcard'
import DetalhamentoCliente from '../detalhamentoCliente/detalhamentoCliente'
import HistoricoAcessos from '../historicoAcessos/historicoAcessos'
import CadastroUsuario from '../usuario/cadastro/cadastro'
import '../../../css/painelVirtueyes/virtuTabelaClientes/tabelaCliente.css'

let contador = 0
let controladorPagina = 1
let totalPaginas = 0
let totalItens = 0
const valorLimite = 50

function transformFiltroComAddress(data) {
  if (!data || Object.keys(data).length === 0) return

  const address = {
    ...(data?.ds_pav_cidade?.length && {
      CIDADE: data.ds_pav_cidade.map((city) => ({
        cityId: city.value,
        stateId: city.stateId
      }))
    }),
    ...(data?.ch_sigla && {
      ESTADO: data.ch_sigla
    })
  }

  const result = {
    ...data,
    ADDRESS: Object.keys(address).length ? address : null
  }

  delete result.ds_pav_cidade
  delete result.ch_sigla

  const finalFiltros = Object.fromEntries(
    Object.entries(result).filter(
      ([, v]) =>
        v !== null && v !== undefined && (!Array.isArray(v) || v.length > 0)
    )
  )

  return finalFiltros
}

const getParams = (busca, separadorLinha) => {
  if (!busca) return ''
  return formatBusca(busca, separadorLinha)
}

const getAllClientes = async (
  paginaAtual,
  linhasPorPagina,
  filtros = {},
  buscar,
  separadorLinhaBusca,
  deveContar,
  limpouBuscaGeral,
  realizouBuscaGeral,
  realizouFiltragem,
  restaurarConfigsIniciaisPagina,
  despacho
) => {
  if (limpouBuscaGeral) {
    despacho(limpouBusca(false))
    restaurarConfigsIniciaisPagina()
  }

  //clicou no botão de busca geral
  if (realizouBuscaGeral) {
    despacho(realizouBusca(false))
    restaurarConfigsIniciaisPagina()
  }

  //clicou no botão para filtro
  if (realizouFiltragem) {
    despacho(realizouFiltro(false))
    restaurarConfigsIniciaisPagina()
  }

  const auxFilter =
    filtros.vazio || Object.keys(filtros).length === 0
      ? undefined
      : transformFiltroComAddress(filtros)

  const filtrarCliente = auxFilter !== undefined

  const montarPayload = (contar) => {
    if (totalPaginas === 0) {
      contador = 0
    } else {
      contador = (paginaAtual - 1) * valorLimite
    }

    const payload = {
      paginaAtual: contador,
      filtros: auxFilter,
      painel_virtueyes: true,
      carregarLimit: linhasPorPagina,
      separadorLinha: separadorLinhaBusca,
      buscar: buscar ? getParams(buscar, separadorLinhaBusca) : undefined
    }

    if (contar) {
      payload.contar = true
    }

    Object.keys(payload).forEach(
      (key) => payload[key] === undefined && delete payload[key]
    )

    return payload
  }

  const payloadContar = montarPayload(true)
  const payloadDados = montarPayload(false)

  let requestComContar

  if (deveContar) {
    if (filtrarCliente) {
      requestComContar = requestResolver(
        api_gateway.post('/m1/filtrar/cliente', payloadContar)
      ).then((res) => res?.[0]?.CONTADOR || 0)
    } else {
      requestComContar = requestResolver(
        api_gateway.get('/m1/consultar/cliente', { params: payloadContar })
      ).then((res) => res?.[0]?.CONTADOR || 0)
    }
  } else {
    requestComContar = Promise.resolve(totalItens)
  }

  let requestDados

  if (filtrarCliente) {
    requestDados = requestResolver(
      api_gateway.post('/m1/filtrar/cliente', payloadDados)
    )
  } else {
    requestDados = requestResolver(
      api_gateway.get('/m1/consultar/cliente', { params: payloadDados })
    )
  }

  return Promise.all([requestComContar, requestDados]).then(
    ([contagem, dados]) => ({
      contagem,
      dados
    })
  )
}

function TabelaClientesVirtueyes() {
  const { mostrarAcao, setRevelarDadosCliente, setIsLoadingGlobal } =
    useGlobal()

  const [itens, setItens] = useState([])
  const [paginaAtual, setPaginaAtual] = useState(1)
  const [renderizar, setRenderizar] = useState(false)
  const [noCdCliente, setNoCdCliente] = useState(-1)
  const [cdCliente, setCdCliente] = useState(-1)
  const [dsCliente, setDsCliente] = useState('NULL')
  const [mensagemErro, setMensagemErro] = useState('')
  const [revelarMensagemSucesso, setRevelarMensagemSucesso] = useState(false)
  const [revelarMensagemErro, setRevelarMensagemErro] = useState(false)
  const [clienteNivel, setClienteNivel] = useState()
  const [bloqueioPorConsumoPercentual, setBloqueioPorConsumoPercentual] =
    useState()
  const [isSelect, setIsSelect] = useState(false)

  let conteudoBusca = useSelector((state) => state.manejadorState.conteudoBusca)
  let limpouBuscaGeral = useSelector(
    (state) => state.manejadorState.limpouBusca
  )
  let realizouBuscaGeral = useSelector(
    (state) => state.manejadorState.realizouBusca
  )
  let revelarHistoricoAcessos = useSelector(
    (state) => state.virtueyesState.revelarHistoricoAcessos
  )
  let revelarAdicionarLogin = useSelector(
    (state) => state.virtueyesState.revelarAdicionarLogin
  )
  let revelarConsultarSimcard = useSelector(
    (state) => state.virtueyesState.revelarConsultarSimcard
  )
  let revelarCadastroCliente = useSelector(
    (state) => state.virtueyesState.revelarCadastroCliente
  )
  let revelarDoppelgangerClienteVar = useSelector(
    (state) => state.virtueyesState.revelarDoppelgangerCliente
  )
  let revelarBarraFiltro = useSelector(
    (state) => state.filtrosState.revelarBarraFiltragem
  )
  let realizouFiltragem = useSelector(
    (state) => state.manejadorState.realizouFiltro
  )
  let estadoExpansaoMenu = useSelector(
    (state) => state.manejadorState.expandirNavegacao
  )
  let visualizarDadosRefreshVar = useSelector(
    (state) => state.virtueyesState.visualizarDadosRefresh
  )
  let filtros = useSelector((state) => state.filtrosState.filtros)
  let revelarCadastrarUsuario = useSelector(
    (state) => state.virtueyesState.revelarCadastrarUsuario
  )
  let separadorLinha = useSelector(
    (state) => state.manejadorState.separadorLinha
  )

  const revelarBloqueioPorConsumo =
    mostrarAcao === 'revelarBloqueioPorConsumoPercentual'

  const codigo_usuario = decryptJWT('codigo')

  const despacho = useDispatch()

  // USABILIDADE
  const [coletaUsabilidade, setColetaUsabilidade] = useState(true)

  useEffect(() => {
    if (coletaUsabilidade) {
      ColetaClickstream(375) // 'virtuTabelaClientesTabelaClientes'
      setColetaUsabilidade(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const deveContar =
    (conteudoBusca && filtros.vazio) ||
    (!filtros.vazio && totalPaginas === 0) ||
    controladorPagina <= paginaAtual ||
    totalPaginas == 0

  useEffect(() => {
    setPaginaAtual(1)
  }, [filtros, conteudoBusca])

  useQuery(
    [
      `/clientes?pagina=${paginaAtual}`,
      paginaAtual,
      valorLimite,
      filtros,
      conteudoBusca
    ],
    async () => {
      setIsLoadingGlobal(true)
      return await getAllClientes(
        paginaAtual,
        valorLimite,
        filtros,
        conteudoBusca,
        separadorLinha,
        deveContar,
        limpouBuscaGeral,
        realizouBuscaGeral,
        realizouFiltragem,
        restaurarConfigsIniciaisPagina,
        despacho
      )
    },
    {
      onSuccess: async (data) => {
        contador = (paginaAtual - 1) * valorLimite
        totalItens = data?.contagem
        totalPaginas = Math.ceil(totalItens / valorLimite)

        const novosItens = []
        data?.dados?.forEach((item, index) => {
          novosItens[contador + index] = item
        })

        setItens(novosItens)

        setIsLoadingGlobal(false)
      },
      onError: () => {
        setIsLoadingGlobal(false)
      },
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      retry: false
    }
  )

  useEffect(() => {
    despacho(mudarManejador('virtueyesClientes'))
    if (!isSelect) {
      despacho(desabilitarAcoes(true))
      despacho(desabilitarAcoesCliente(true))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  async function handleCarregarCliente() {
    setIsLoadingGlobal(true)

    const payload_usuario = {
      dados: {
        ds_cliente_texto: noCdCliente,
        cd_pav_cliente: cdCliente
      },
      condicao: {
        cd_pav_usuario: codigo_usuario
      },
      painel_virtueyes: true
    }

    await api_gateway.post('/m1/alterar/usuario', payload_usuario)

    let fatContas = []
    const contasUsuario = await api_gateway.get(
      `/m1/consultar/fat_conta/contas_usuario?cd_pav_usuario=${codigo_usuario}`
    )
    await Promise.all(
      contasUsuario.data.dados.map((item) => {
        fatContas.push(item.cd_fat_conta)
      })
    )
    if (contasUsuario.data.dados.length == 0) {
      fatContas = [0]
    }

    const payload = {
      login: decryptJWT('login'),
      email: decryptJWT('email'),
      codigo: codigo_usuario,
      codigoCliente: cdCliente,
      codigoClienteErpAntigo: noCdCliente,
      codigoClienteTexto: noCdCliente,
      nomeDeUsuario: decryptJWT('nomeDeUsuario'),
      perfil: decryptJWT('perfil'),
      cdSmsContaUsuario: decryptJWT('cdSmsContaUsuario'),
      id: decryptJWT('id'),
      fatContas: fatContas.join(','),
      clienteNivel: clienteNivel,
      tipoPerfil: decryptJWT('tipoPerfil'),
      clientePrimario: decryptJWT('clientePrimario'),
      clienteOriginal: decryptJWT('clienteOriginal'),
      cd_sol_perfil: decryptJWT('cd_sol_perfil'),
      userHasSMS: decryptJWT('userHasSMS'),
      fl_enviar_fora_parque: decryptJWT('fl_enviar_fora_parque')

    }

    try {
      const resposta = await api_gateway.get('/m1/servicos/alterar_token', {
        params: payload
      })

      localStorage.setItem('@veye-Token', resposta.data.dados.token)

      await api_gateway.get(
        `/m1/servicos/token/atualizarLogin?cd_pav_usuario=${codigo_usuario}`
      )

      if ('keyOperadora' in localStorage) {
        localStorage.removeItem('keyOperadora')
      }
      if ('keyStatusContrato' in localStorage) {
        localStorage.removeItem('keyStatusContrato')
      }

      localStorage.removeItem('temLinhasVivo')
      localStorage.setItem('codigoClienteErpAntigo', noCdCliente)

      setRevelarMensagemSucesso(true)
      setRevelarDadosCliente(true)
      despacho(revelarDoppelgangerCliente(false))
      despacho(visualizarDadosRefresh(!visualizarDadosRefreshVar))
    } catch (error) {
      setMensagemErro(error?.response?.data?.info)
      setRevelarMensagemErro(true)
    }

    setIsLoadingGlobal(false)
    despacho(mudarDoppleGangerCliente(false))
  }

  useEffect(() => {
    if (cdCliente > 0 && revelarDoppelgangerClienteVar === true) {
      handleCarregarCliente()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [revelarDoppelgangerClienteVar])

  const itemExpandido = {
    className: 'fundo-cor-1',
    renderer: (row) => (
      <div
        className={
          estadoExpansaoMenu === true
            ? 'expand-row-tabela-clientes-virtueyes-1'
            : 'expand-row-tabela-clientes-virtueyes-2'
        }
      >
        <DetalhamentoCliente
          noCdCliente={row.n0_codigo_cliente}
          cdCliente={row.cd_pav_cliente}
          logradourocliente={row.logradouro}
          bairrocliente={row.bairro}
          ufcliente={row.uf}
          cidadecliente={row.cidade}
          cepcliente={row.cep}
          vendedorcliente={row.ds_nome}
          cpfVendedorCliente={row.ds_cpf}
          emailVendedorCliente={row.ds_email}
          telefoneVendedorCliente={row.ds_telefone}
        />
      </div>
    ),
    expandHeaderColumnRenderer: () => <div className="tela-background" />,
    expandColumnRenderer: (rowKey) => {
      return (
        <Button
          className="botao-expandir-row"
          onClick={() => GirarSetaDropdown(rowKey.rowKey)}
        >
          <Image
            id={rowKey.rowKey}
            className="icone-botao-expandir-row nao-selecionavel"
            src={setaDropdown()}
          />
        </Button>
      )
    },
    showExpandColumn: true,
    expandByColumnOnly: true,
    headerClasses: 'tabela-coluna-primeira-header'
  }

  const colunas = [
    {
      dataField: 'n0_codigo_cliente',
      headerClasses: 'nao-selecionavel',
      text: 'Código',
      formatter: (cell) => {
        return <p className="fonte-cor-1 label-tabela-1">{cell || '-'}</p>
      }
    },
    {
      dataField: 'ds_pav_cliente',
      headerClasses: 'nao-selecionavel',
      text: 'Razão social',
      sort: true,
      formatter: (cell) => {
        return <p className="fonte-cor-1 label-tabela-1">{cell || '-'}</p>
      }
    },
    {
      dataField: 'ds_nome_fantasia',
      headerClasses: 'nao-selecionavel',
      text: 'Nome fantasia',
      sort: true,
      formatter: (cell) => {
        return <p className="fonte-cor-1 label-tabela-1">{cell || '-'}</p>
      }
    },
    {
      dataField: 'vendedor',
      headerClasses: 'nao-selecionavel',
      text: 'Atendido por',
      sort: true,
      formatter: (cell) => {
        return <p className="fonte-cor-1 label-tabela-1">{cell || '-'}</p>
      }
    },
    {
      dataField: 'ds_cnpj',
      headerClasses: 'nao-selecionavel',
      text: 'CNPJ',
      sort: true,
      formatter: (cell) => {
        return <p className="fonte-cor-1 label-tabela-1">{cell || '-'}</p>
      }
    },
    {
      dataField: 'ds_telefone',
      headerClasses: 'nao-selecionavel',
      text: 'Telefone',
      sort: true,
      formatter: (cell) => {
        return <p className="fonte-cor-1 label-tabela-1">{cell || '-'}</p>
      }
    },
    {
      dataField: 'ds_cliente_origem',
      headerClasses: 'nao-selecionavel',
      text: 'Cliente pertencente',
      sort: true,
      formatter: (cell) => {
        return <p className="fonte-cor-1 label-tabela-1"> {cell || '-'}</p>
      }
    },
    {
      dataField: 'ultimo_acesso',
      headerClasses: 'nao-selecionavel',
      text: 'Último acesso',
      sort: true,
      formatter: (cell) => {
        if (cell) {
          cell = cell.replace('T', ' ').split('.')
          if (cell.length > 0) {
            cell = cell[0]
          }
        }
        return cell ? formatarData(cell) : '-'
      }
    },
    {
      dataField: 'fl_bloquear_ao_exceder',
      headerClasses: 'nao-selecionavel',
      text: 'Bloqueio por consumo percentual',
      sort: true,
      formatter: (cell) => {
        const auxCell = cell === 1 ? 'Ativo' : cell === 0 ? 'Inativo' : '-'
        return <p className="fonte-cor-1 label-tabela-1"> {auxCell}</p>
      }
    }
  ]

  const selecaoLinhas = {
    mode: 'radio',
    onSelect: (row, isSelect) => {
      setIsSelect(isSelect)
      if (isSelect) {
        handleSelecionarCliente(
          row.cd_pav_cliente,
          row.ds_pav_cliente,
          row.n0_codigo_cliente,
          row.n0_nivel,
          row.fl_bloquear_ao_exceder
        )
      }
    },
    selectionRenderer: ({ mode }) => {
      return (
        <label className="label-checkbox-cliente-virtueyes fonte-cor-1">
          <input type={mode} id=" CLIENTEVEYE" name="CLIENTE" />
          <span className="checkbox-cliente-virtueyes radio-button-cor-1" />
        </label>
      )
    }
  }

  function handleSelecionarCliente(
    codigo_cliente,
    nome_cliente,
    n0_codigo_cliente,
    n0_nivel,
    fl_bloquear_ao_exceder
  ) {
    setNoCdCliente(n0_codigo_cliente)
    setCdCliente(codigo_cliente)
    setDsCliente(nome_cliente)
    setClienteNivel(n0_nivel)
    setBloqueioPorConsumoPercentual(fl_bloquear_ao_exceder)
    despacho(desabilitarAcoes(false))
  }

  const eventosLinhas = {
    onClick: (e, row) => {
      setNoCdCliente(row.n0_codigo_cliente)
      setCdCliente(row.codigo)
      setDsCliente(row.cliente)
      setClienteNivel(row.n0_nivel)
      setBloqueioPorConsumoPercentual(row.fl_bloquear_ao_exceder)
    }
  }

  const trocarPagina = (novaPagina) => {
    if (totalPaginas <= 1) return

    setPaginaAtual(novaPagina)
  }

  const opcoesPaginacao = {
    page: paginaAtual,
    showTotal: true,
    sizePerPage: valorLimite,
    firstPageTitle: 'Primeira',
    lastPageTitle: 'Última',
    nextPageTitle: 'Proxima',
    prePageTitle: 'Anterior',
    custom: true,
    onPageChange: (newPage) => {
      trocarPagina(newPage)
    }
  }

  function restaurarConfigsIniciaisPagina() {
    totalPaginas = 0
    contador = 0
    controladorPagina = 1
    totalItens = 0
    despacho(desabilitarAcoes(true))
    setPaginaAtual(1)
  }

  function handleMensagemSucesso() {
    if (revelarMensagemSucesso === false) {
      setRevelarMensagemSucesso(true)
    } else {
      setRevelarMensagemSucesso(false)
    }
  }

  function handleMensagemErro() {
    if (revelarMensagemErro === false) {
      setRevelarMensagemErro(true)
    } else {
      setRevelarMensagemErro(false)
    }
  }

  return (
    <div className="container-tela">
      {revelarBloqueioPorConsumo && (
        <BloqueioPorConsumoPercentual
          codigoCliente={cdCliente}
          bloqueioPorConsumo={bloqueioPorConsumoPercentual}
          onFinish={(bloquear) => {
            setBloqueioPorConsumoPercentual(bloquear)

            const index = itens.findIndex(
              (item) => item.cd_pav_cliente === cdCliente
            )
            if (index === -1) return

            const novoItem = {
              ...itens[index],
              fl_bloquear_ao_exceder: bloquear
            }

            const novosItens = [...itens]
            novosItens[index] = novoItem

            setItens(novosItens)
          }}
        />
      )}
      {revelarBloqueioPorConsumo && (
        <BloqueioPorConsumoPercentual
          codigoCliente={cdCliente}
          bloqueioPorConsumo={bloqueioPorConsumoPercentual}
          onFinish={(bloquear) => {
            setBloqueioPorConsumoPercentual(bloquear)

            const index = itens.findIndex(
              (item) => item.cd_pav_cliente === cdCliente
            )
            if (index === -1) return

            const novoItem = {
              ...itens[index],
              fl_bloquear_ao_exceder: bloquear
            }

            const novosItens = [...itens]
            novosItens[index] = novoItem

            setItens(novosItens)
          }}
        />
      )}
      {revelarMensagemSucesso && (
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <MensagemSucesso
              handleMensagemSucesso={handleMensagemSucesso}
              mensagemTitulo="Sucesso"
              mensagemParagrafo1={'O cliente ' + dsCliente + ','}
              mensagemParagrafo2={'cód. ' + noCdCliente + ' foi carregado.'}
              mensagemBotao="OK"
            />
          </div>
        </div>
      )}
      {revelarMensagemErro && (
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <MensagemErro
              centralizarBotao
              handleMensagemErro={handleMensagemErro}
              mensagemTitulo="Erro"
              mensagemParagrafo1="Ocorreu um erro. Tente novamente mais tarde."
              mensagemParagrafo2="Caso o erro persista, entre em contato com o Suporte."
              mensagemParagrafo3={mensagemErro}
              mensagemBotao="Retornar"
            />
          </div>
        </div>
      )}
      {revelarCadastroCliente === true && (
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <CadastroCliente
              renderizar={renderizar}
              setRenderizar={setRenderizar}
            />
          </div>
        </div>
      )}
      {revelarHistoricoAcessos === true && (
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <HistoricoAcessos codigo_cliente={noCdCliente} />
          </div>
        </div>
      )}
      {revelarCadastrarUsuario === true && (
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <CadastroUsuario
              tituloJanela="Cadastrar"
              renderizar={renderizar}
              setRenderizar={setRenderizar}
            />
          </div>
        </div>
      )}
      {revelarAdicionarLogin === true && (
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <AdicionarLogin
              renderizar={renderizar}
              setRenderizar={setRenderizar}
              codigo_cliente={cdCliente}
            />
          </div>
        </div>
      )}
      {revelarConsultarSimcard === true && (
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <ConsultarSimcard />
          </div>
        </div>
      )}
      <BarraDadosCliente />
      {revelarBarraFiltro === true && <BarraFiltragem />}
      <PaginationProvider pagination={Paginador(opcoesPaginacao)}>
        {({ paginationProps, paginationTableProps }) => (
          <>
            <BootstrapTable
              classes="tabela"
              condensed
              keyField="cd_pav_cliente"
              data={itens}
              columns={colunas}
              rowEvents={eventosLinhas}
              selectRow={selecaoLinhas}
              expandRow={itemExpandido}
              noDataIndication="Nenhum item encontrado"
              {...paginationTableProps}
            />
            <PaginacaoTabela
              setPaginaAtual={setPaginaAtual}
              totalPaginas={totalPaginas}
              totalItens={totalItens}
              valorLimite={valorLimite}
              paginaAtual={paginaAtual}
              page={paginationProps.page}
              onPageChange={paginationProps.onPageChange}
            />
          </>
        )}
      </PaginationProvider>
      <div className="itens-exibidos-tabela fonte-cor-1">
        Mostrando
        <span className="label-tabela-itens-exibidos">{contador + 1}</span>-
        <span className="label-tabela-itens-exibidos">
          {contador + valorLimite <= totalItens
            ? contador + valorLimite
            : totalItens}
        </span>
        de
        <span className="label-tabela-itens-exibidos">{totalItens}</span>
      </div>
    </div>
  )
}

function mapStateToProps(state) {
  return {
    conteudoBusca: state.manejadorState.conteudoBusca,
    filtros: state.filtrosState.filtros
  }
}
//React.memo - nao permitir a renderizacao se o state e o props nao mudarem de estado
export default connect(mapStateToProps)(React.memo(TabelaClientesVirtueyes))
